function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { clearCachedCurrentToken } from './cache';
import { getCurrentToken } from './getCurrentToken';
import handleFetchErrors from '../helpers/handleFetchErrors';
const handle401 = response => {
  if (response.status === 401) {
    clearCachedCurrentToken();
    // When getting 401, we want to try and get a new token.
    // getCurrentToken would redirect the user to the needed login URL if needed.
    // If the new login was successful (should happen rarely) - we want to return the response with error and let the consumer decide whether to make another request.
    return getCurrentToken().then(() => response);
  }
  return response;
};
export const fetchResponseWithToken = (url, fetchData) => {
  return getCurrentToken().then(_ref => {
    let {
      accessToken
    } = _ref;
    return fetch(url, _objectSpread(_objectSpread({}, fetchData), {}, {
      headers: _objectSpread(_objectSpread({}, fetchData && fetchData.headers), {}, {
        Authorization: "Bearer ".concat(accessToken)
      })
    }));
  }).then(handle401);
};
export const fetchWithToken = (url, fetchData) => {
  return fetchResponseWithToken(url, fetchData).then(handleFetchErrors).then(res => res.text()) // check if res body exists before trying to json parse it - to avoid parsing errors
  .then(text => text ? JSON.parse(text) : {});
};
//# sourceMappingURL=fetchWithToken.js.map